import {
    ILstParcelasAtrasoPorClienteBody,
    INegativarParcelasClientes,
} from "../../../Interfaces/Cobranca/Serasa/Negativar";
import {
    ExecutarNegativacaoClienteSerasaService,
    ListarClientesParcelasAtrasoSerasaExportarExcelService,
    ListarClientesParcelasAtrasoSerasaService,
    ListarParcelasAtrasoPorClienteSerasaExportarExcelService,
    ListarParcelasAtrasoPorClienteSerasaService,
} from "../../../Services/Cobranca/Serasa/Negativar";
import { Controller } from "../../Controller";

export async function ListarClientesParcelasAtrasoSerasaController(
    PAGINA: number,
    requestBody: {
        DS_CLIENTE: string;
        ID_EMPREENDIMENTO: string | number[];
        NR_CPF_CNPJ: string;
        DS_TIPO_CLIENTE: string;
        ID_TIPO_CLIENTE: number;
        DS_STATUS_PARCELA: string;
        NR_VENDA: string;
        QUANTIDADE: number;
        PAGINA: number;
    }
) {
    return Controller(
        ListarClientesParcelasAtrasoSerasaService(PAGINA, requestBody)
    );
}

export async function ListarClientesParcelasAtrasoSerasaExportarExcelController(
    PAGINA: number,
    requestBody: {
        DS_CLIENTE: string;
        ID_EMPREENDIMENTO: string | number[];
        NR_CPF_CNPJ: string;
        DS_TIPO_CLIENTE: string;
        NR_VENDA: string;
        QUANTIDADE: number;
        PAGINA: number;
    },
    flExcel?: boolean
) {
    return Controller(
        ListarClientesParcelasAtrasoSerasaExportarExcelService(
            PAGINA,
            requestBody,
            flExcel
        )
    );
}

export async function ListarParcelasAtrasoPorClienteSerasaController(
    PAGINA: number,
    QUANTIDADE: number,
    requestBody: {
        DS_NOME: string;
        ID_CHAVE_ERP: string;
        DS_STATUS: string;
        DS_TIPO_CLIENTE?: boolean;
    }
) {
    return Controller(
        ListarParcelasAtrasoPorClienteSerasaService(
            PAGINA,
            QUANTIDADE,
            requestBody
        )
    );
}

export async function ListarParcelasAtrasoPorClienteSerasaExportarExcelController(
    PAGINA: number,
    QUANTIDADE: number,
    requestBody: ILstParcelasAtrasoPorClienteBody,
    flExcel?: boolean
) {
    return Controller(
        ListarParcelasAtrasoPorClienteSerasaExportarExcelService(
            PAGINA,
            QUANTIDADE,
            requestBody,
            flExcel
        )
    );
}

export async function ExecutarNegativacaoClienteSerasaController(
    requestBody: Array<INegativarParcelasClientes>
) {
    return Controller(ExecutarNegativacaoClienteSerasaService(requestBody));
}
